import styled from 'styled-components';

export const ProductDescription = styled.div`
  color: var(--foreground);
  /* Because we use reset.css, these rules reintroduce styling for common HTML elements. */
  & p:not(:first-of-type) {
    margin-top: 12px;
  }
  & strong {
    font-weight: bold;
  }
`;

export default {};
